
const mEventReportData = new WeakMap();
const mEventTotalCount = new WeakMap();
const mSortFn = new WeakMap();

const mSortReverse = new WeakMap();
const mCurrentSort = new WeakMap();

const sortStates = Object.freeze({
    State: "State",
    EventCount: "Event Count"
});

const SortByStateFn = (reportElement) => reportElement.state.sortAs;
const SortByEventCountFn = (reportElement) => reportElement.stateEventCount;

class StateEventReportDataContainer {
    constructor() {
        mEventReportData.set(this, []);
        mEventTotalCount.set(this, 0);
        mSortReverse.set(this, false);
        mCurrentSort.set(this, sortStates.State);
        mSortFn.set(this, SortByStateFn);
    }

    get eventReportData() {
        return mEventReportData.get(this);
    }

    get eventTotalCount() {
        return mEventTotalCount.get(this);
    }

    set eventTotalCount(updatedCount) {
        if (updatedCount == null) {
            mEventTotalCount.set(this, 0);
        }
        else if ((Number.isInteger(updatedCount)) && (updatedCount >= 0)) {
            mEventTotalCount.set(this, updatedCount);
        }
        else {
            throw new TypeError("Invalid Event Total Count Value");
        }
    }

    get sortReverse() {
        return mSortReverse.get(this);
    }

    get currentSort() {
        return mCurrentSort.get(this);
    }

    get sortFn() {
        return mSortFn.get(this);
    }
    
    clearData() {
        mEventReportData.get(this).length = 0;
        mEventTotalCount.set(this, 0);
    }

    sortByState() {
        if (this.currentSort === sortStates.State) {
            mSortReverse.set(this, !this.sortReverse);
        }
        else {
            mSortFn.set(this, SortByStateFn);
            mSortReverse.set(this, false);
            mCurrentSort.set(this, sortStates.State);
        }
    }

    sortByNumberOfEvents() {
        if (this.currentSort === sortStates.EventCount) {
            mSortReverse.set(this, !this.sortReverse);
        }
        else {
            mSortFn.set(this, SortByEventCountFn);
            mSortReverse.set(this, true);
            mCurrentSort.set(this, sortStates.EventCount);
        }
    }
}

export default StateEventReportDataContainer;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-reports/StateEventReportDataContainer.js
// module id = SFix
// module chunks = 1